import { useReward } from '@/contexts/reward-context';
import { CloseIcon, RankIcon, ShopCoinIcon, StoreIcon } from '../svg-icons';
import { NewVersionInfo } from '@/types';
import { useEffect, useState } from 'react';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

export const NewVersionPopup = () => {
	const { labels, onClose, getNewVersionInfo } = useReward();
	const [newVersionInfo, setNewVersionInfo] = useState<NewVersionInfo>();
	const [example3Html, setExample3Html] = useState('');
	const [example5Html, setExample5Html] = useState('');
	const [finalSabaCoins, setFinalSabaCoins] = useState(0);

	const getExample3html = () => {
		return labels?.lbl_RPRebateExample3?.replace('{0}', newVersionInfo?.Currency ?? '').replace('{1}', '' + newVersionInfo?.RebateRate) ?? '';
	}

	const getExample5html = () => {
		return labels?.lbl_RPRebateExample5?.replace('{0}', newVersionInfo?.ActualRate + ' ') ?? '';
	}

	useEffect(() => {
		if (getNewVersionInfo) {
			getNewVersionInfo().then((records: NewVersionInfo) => {
				if (records) {
					setNewVersionInfo(records);
				}
			});
		}
	}, []);

	useEffect(() => {
		if (labels && newVersionInfo) {
			setExample3Html(getExample3html);
			setExample5Html(getExample5html);
			setFinalSabaCoins(10 * newVersionInfo.RebateRate * newVersionInfo.ActualRate * 100);
		}
	}, [labels, newVersionInfo]);

	return (
		<RewardModalWrapper>
			<section className="reward-new-version">
				<div className="reward-scroller">
					<div className="reward-new-version__btn-close" onClick={onClose}>
						<CloseIcon />
					</div>
					<div className="reward-new-version__header">
						<div className="reward-new-version-title">
							<div className="reward-new-version-title__sub-title">{labels?.lbl_RPPampersYou}</div>
							<div className="reward-new-version-title__title">{labels?.lbl_RPNewSabaReward}</div>
							<div className="reward-new-version-title__info">{labels?.lbl_RPUpgrade}</div>
						</div>
						<div className="reward-new-version-feature">
							<div className="reward-new-version-feature__bg-vip"></div>
							<div className="reward-new-version-feature__title">{labels?.lbl_RPBrandNewDebut}</div>
							<div className="reward-new-version-feature__list">
								<div className="reward-new-version-feature__item">
									<StoreIcon />
									{labels?.lbl_RPSabaShop}
								</div>
								<div className="reward-new-version-feature__item">
									<ShopCoinIcon />
									{labels?.lbl_RPSabaCoins}
								</div>
								<div className="reward-new-version-feature__item">
									<RankIcon />
									{labels?.lbl_RPSabaRank}
								</div>
							</div>
						</div>
						<div className="reward-new-version-coin reward-new-version-coin--left"></div>
						<div className="reward-new-version-coin reward-new-version-coin--right"></div>
						<div className="reward-new-version-coin reward-new-version-coin--small"></div>
					</div>
					<div className="reward-new-version__body">
						<div className="reward-new-version-title">
							<div className="reward-new-version-title__sub-title">{labels?.lbl_RPEarnSabaCoins}</div>
							<div className="reward-new-version-title__title">{labels?.lbl_RPExploreSabaShop}</div>
							<div className="reward-new-version-title__info">{labels?.lbl_RPDiverseVouchers}</div>
						</div>
						<div className="reward-new-version-shop">
							<div className="reward-new-version-shop__item reward-new-version-shop__item--shield">
								<i className="reward-icon-voucher-shield"></i>
								<div className="reward-new-version-shop__text">
									<div className="reward-new-version-shop__name">{labels?.lbl_RPRiskFreeBet}</div>
									<div className="reward-new-version-shop__info">{labels?.lbl_RPBeRelieved}</div>
								</div>
							</div>
						</div>
						<div className="reward-new-version-rank">
							<div className="reward-new-version-rank__img"></div>
							<div className="reward-new-version-rank__text">
								{labels?.lbl_RPTop10OnRankings}
								<div dangerouslySetInnerHTML={{ __html: labels?.lbl_RPSpecialVouchersWeekly ?? '' }} />
							</div>
						</div>
						<div className="reward-new-version-intro">
							<div className="reward-new-version-intro__title">{labels?.lbl_RPObtainSabaCoins}</div>
							<div className="reward-new-version-intro__item reward-new-version-intro__item--turntable">
								<div className="reward-new-version-intro__item-text">
									<div className="reward-new-version-intro__item-highlight">{labels?.lbl_RPCheckInEveryday1}</div>
									{labels?.lbl_RPCheckInEveryday2}
								</div>
								<div className="reward-new-version-intro__item-img"></div>
							</div>
							<div className="reward-new-version-intro__item reward-new-version-intro__item--rebate">
								<div className="reward-new-version-intro__item-text">
									<div className="reward-new-version-intro__item-highlight">{labels?.lbl_RPBettingSubsidy1}</div>
									{labels?.lbl_RPBettingSubsidy2}
								</div>
								<div className="reward-new-version-intro__item-img"></div>
							</div>
							<div className="reward-new-version-example" dangerouslySetInnerHTML={{ __html: labels?.lbl_RPRebateExample1 ?? '' }} />
							<div className="reward-new-version-panel">
								<div className="reward-new-version-panel__label">{labels?.lbl_RPRebateExample2}</div>
								<div className="reward-new-version-panel__text" dangerouslySetInnerHTML={{ __html: example3Html }} />
							</div>
							<div className="reward-new-version-row">
								<span className="reward-new-version-row__multiply">X</span>
							</div>
							<div className="reward-new-version-panel">
								<div className="reward-new-version-panel__label">{labels?.lbl_RPRebateExample4}</div>
								<div className="reward-new-version-panel__text" dangerouslySetInnerHTML={{ __html: example5Html }} />
							</div>
							<div className="reward-new-version-row">
								<span className="reward-new-version-row__equal">=</span>
							</div>
							<div className="reward-new-version-row">
								<i className="reward-iconcolor-shop-coin"></i>
								<span className="reward-new-version-row__coin"> {finalSabaCoins}</span>
							</div>
							<div className="reward-new-version-msg">
								{labels?.lbl_RPRebateExample6}
							</div>
							<div className="reward-new-version-coin reward-new-version-coin--left"></div>
							<div className="reward-new-version-coin reward-new-version-coin--right"></div>
						</div>
						<div className="reward-new-version-title">
							<div className="reward-new-version-title__sub-title">{labels?.lbl_RPBeyondExperience}</div>
							<div className="reward-new-version-title__title">{labels?.lbl_RevealPrivilegeKeys}</div>
							<div className="reward-new-version-title__info">{labels?.lbl_RPNewLevelUnlocked}<br />{labels?.lbl_RPCompleteTask}</div>
						</div>
						<div className="reward-new-version-level">
							<div className="reward-badge-level" data-level="4" data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
							<div className="reward-badge-level" data-level="5" data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
							<div className="reward-badge-level" data-level="6" data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
							<div className="reward-badge-level" data-level="7" data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
							<div className="reward-badge-level" data-level="8" data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
						</div>
						<div className="reward-new-version-tags">
							<div className="reward-new-version-tag">{labels?.lbl_RPGuaranteedSabaCoins}</div>
							<div className="reward-new-version-tag">{labels?.lbl_RPWeeklyReward}</div>
							<div className="reward-new-version-tag">{labels?.lbl_RPRankingHonor}</div>
							<div className="reward-new-version-tag">{labels?.lbl_RPExclusiveVouchers}</div>
						</div>
					</div>
					<div className="reward-new-version__footer">
						{labels?.lbl_RPMoreDetails}
					</div>
				</div>
			</section>
		</RewardModalWrapper>
	);
}

